import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { gtmEventsService } from "@/components/third-party-scripts/google-tag-manager/gtm-events-service";
import { GtmEventName, GtmTrackData, GtmTrackOptions } from "@/components/third-party-scripts/google-tag-manager/gtm-events-types";
export const useGtm = () => {
  const $ = _c(1);
  const track = _temp;
  const trackCustom = _temp2;
  const trackPageView = _temp3;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      track,
      trackCustom,
      trackPageView
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(eventName, data, options) {
  return gtmEventsService.track(eventName, data, options);
}
function _temp2(eventName_0, data_0) {
  return gtmEventsService.trackCustom(eventName_0, data_0);
}
function _temp3() {
  return gtmEventsService.track("page_view", {});
}